import { render, staticRenderFns } from "./ModalInstrument.vue?vue&type=template&id=1528ac5c"
import script from "./ModalInstrument.vue?vue&type=script&lang=js"
export * from "./ModalInstrument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports